<template>
  <div class="box">
    <vue-loading v-if="loading" :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>
    <div class="assets">
      <div class="report">
        <vue-good-table
          :columns="columns"
          :rows="filtered_assets"
          :search-options="{
            enabled: true,
            skipDiacritics: true,
            placeholder: 'filter'
          }"
          :pagination-options="{
            enabled: true,
            perPage: 50,
          }"
          styleClass="vgt-table condensed">
        </vue-good-table>
      </div>
      <transition>
        <div class="panel">
          <div class="heading">
            <h4>Assets</h4>
          </div>

            <div class="assets-download">
              <button type="button" class="btn btn-sm btn-primary" v-on:click="downloadCSV()">Download Report</button>
            </div>

            <div class="details">
              <div class="detail">
                <div class="services" v-for="service in all_services" :key="service">
                  <div class="service" v-on:click="setSelectedService(service)" @mouseover="hoverService = service" @mouseout="hoverService = null" v-bind:class="[ {'active-service': (selectedService == service)},{'hover-service': (hoverService == service && selectedService != service)},{'inactive-service': (selectedService != service && hoverService != service)} ]">
                    {{ service }}
                  </div>
                </div>
              </div>
            </div>

        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import HTTP from '@/common/http'
import { mapGetters } from 'vuex'
import VueLoading from 'vue-loading-overlay'
import axios from 'axios'

export default {
  components: {
    VueLoading
  },
  props: [
    'id',
    'resource'
  ],
  computed: {
    ...mapGetters([
      'activeType'
    ]),
    all_tags () {
      const tags = new Set()
      for (let i = 0; i < this.assets.length; i++) {
        for (const [key] of Object.entries(this.assets[i].tags)) {
          tags.add(key)
        }
      }
      return Array.from(tags)
    },
    all_services () {
      let services = this.assets.map(item => item.service).filter((value, index, self) => self.indexOf(value) === index)
      return services.sort()
    },
    filtered_assets () {
      let selectedService = this.selectedService
      if (selectedService) {
        return this.assets.filter(function (el) { return el.service === selectedService })
      } else {
        return this.assets
      }
    },
    large_dataset () {
      return this.assets.length > 100000
    }
  },
  created: function () {
    this.getData()
  },
  methods: {
    downloadCSV: function () {
      this.flashMessage.info({
        message: 'Generating assets CSV report',
        time: 3000
      })
      HTTP.get(`assets/${this.activeType}/${this.id}/csv`)
        .then((response) => {
          window.location = response.data.signedUrl
          this.flashMessage.success({
            message: 'Assets CSV report generation complete'
          })
        })
        .catch((error) => {
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: `Failed to generate assets CSV report : ${msg}`
          })
        })
    },
    getData: function () {
      this.loading = true
      HTTP.get(`assets/${this.activeType}/${this.id}`)
        .then((response) => {
          // Response data is an s3 presigned url
          this.assetsUrl = response.data
          // Sent http request to retrieve json file from s3 url
          axios.get(this.assetsUrl)
            .then((res) => {
              this.assets = res.data.assets
              if (this.large_dataset) {
                this.selectedService = this.all_services[0]
              }
            })
            .catch((error) => {
              this.flashMessage.error({
                message: `Failed to get Assets Summary payload: ${error.message}`
              })
            })
            .finally(() => {
              this.loading = false
            })
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to get Assets Url: ${error.message}`
          })
          this.loading = false
        })
    },
    setSelectedService: function (service) {
      if (this.selectedService !== service) {
        this.selectedService = service
      } else if (!this.large_dataset) {
        this.selectedService = null
      }
    }
  },
  data () {
    return {
      loading: false,
      assets: [],
      selectedService: null,
      hoverService: null,
      columns: [
        {
          label: 'Contract',
          field: 'Contract',
          type: 'string'
        },
        {
          label: 'Account',
          field: 'AccountName',
          type: 'string'
        },
        {
          label: 'Region',
          field: 'region',
          type: 'string',
          width: '120px'
        },
        {
          label: 'Service',
          field: 'service',
          type: 'string'
        },
        {
          label: 'Resource Type',
          field: 'resource_type',
          type: 'string'
        },
        {
          label: 'Resource ID',
          field: 'resource_id',
          type: 'string'
        }
      ]
    }
  },
  watch: {
    id: function () {
      this.selectedService = null
      this.assets = []
      this.getData()
    }
  }
}
</script>

<style scoped>
.assets {
  display: flex;
}
.panel {
  padding: 20px;
  display: inline-block;
  position: relative;
  width: 25%;
  border: 1px solid #dcdfe6;
  margin: 20px;
}
.report {
  padding: 20px;
  padding-right: 0px;
  display: inline-block;
  position: relative;
  width: 75%;
}
@media screen and (min-width: 1400px) {
  /deep/ .vgt-left-align {
    font-size: 13px;
  }
  /deep/ .vgt-right-align {
    font-size: 13px;
  }
}
@media screen and (max-width: 1400px) {
  /deep/ .vgt-left-align {
    font-size: 11px;
  }
  /deep/ .vgt-right-align {
    font-size: 11px;
  }
}
.assets-download {
  top: 20px;
  right: 20px;
  position: absolute;
  cursor: pointer;
  z-index: 1;
}
.details {
  font-size: 12px;
}
.detail {
  padding-top: 10px;
}
.detail h6 {
  padding-top: 18px;
}
.filter-icon {
  margin-right: 5px;
}
.filter-icon:hover {
  transition: opacity 200ms;
  opacity: 0.8;
}
.value {
  padding-top: 3px;
  padding-left: 25px;
  padding-bottom: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.services {
  padding-left: 0px;
}
.service {
  margin-top: 10px;
  padding-left: 6px;
  margin-left: -6px;
  font-size: 12px;
  cursor: pointer;
}
.enabledCol {
  cursor: pointer;
  opacity: 1;
  filter: grayscale(0);
}
.disabledCol {
  cursor: pointer;
  opacity: 0.6;
  filter: grayscale(1.0);
}
.active-service {
  border-left: 6px solid #77a6f7;
}
.hover-service {
  border-left: 6px solid #aaaaaa;
}
.inactive-service {
  border-left: 6px solid #ffffff;
}

</style>



// WEBPACK FOOTER //
// src/views/Assets.vue